import create from "zustand";
import { getLocales, Language } from "../models/Locale";
import { normalizeLocale } from "@/utils/locale";

const DEFAULT_LOCALE = "en_US";

export type AvailableLocaleCodes = "en" | "en_US" | "en_GB" | "es" | "es_ES" | "es_MX" | "fr" | "de";

interface LocalizationStoreState {
    locale: AvailableLocaleCodes;
    availableLanguages: Language[];
    getLocale: () => string;
    setAvailableLanguages: (languages: Language[]) => void;
}

/**
 * Localization store is used to store the data used for
 * accessing across the app like availableLanguages
 *
 * we need to use store since we need to fetch the languages only
 * after initializing Localise JS
 *
 */

export const useLocalizationStore = create<LocalizationStoreState>((set) => ({
    locale: DEFAULT_LOCALE,

    availableLanguages: [],

    getLocale() {
        return normalizeLocale(this.locale) ?? DEFAULT_LOCALE;
    },

    setAvailableLanguages(languages: Language[]) {
        set({ availableLanguages: getLocales(languages) });
    },
}));
